import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '', loadComponent: () => import('../app/detail-lock/detail-lock.component').then(c => c.DetailLockComponent)
    },
    {
        path: 'social-media', loadComponent: () => import('../app/social-media/social-media.component').then(c => c.SocialMediaComponent)
    },
    {
        path: 'privacy-policy', loadComponent: () => import('../app/privacy-policy/privacy-policy.component').then(c => c.PrivacyPolicyComponent)
    },
    {
        path:'**', loadComponent: () => import('../app/shared/component/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
    }
];
